import {
  Box,
  Button,
  Flex,
  Icon,
  Img,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useRef, createRef } from "react";
import { useNavigate } from "react-router-dom";
import { GRAY } from "../../../../constants/colors";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ModalContentToPrint from "./modalContentToPrint";

export default function ModalSalesListDetail({ isOpen, setIsOpen, item }: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  const onClose = () => {
    setIsOpen(false);
  };
  const componentRef: any = createRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Detalhes da Transação</Text>
            </Flex>
          </ModalHeader>
          <ModalContentToPrint item={item} ref={componentRef} />
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            <ReactToPrint
              trigger={() => (
                <Button background={GRAY} color={"white"} mr={3}>
                  Imprimir
                </Button>
              )}
              content={() => componentRef.current}
              documentTitle={"comprovante-pagamento"}
            />
            {/* <Button
              background={GRAY}
              color={"white"}
              mr={3}
              onClick={handlePrint}
            >
              Print função
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
